/*
 *
 * Plans actions
 *
 */

import {
  FLUSH_STATE_PLANS,
  LOAD_PLANS,
  LOAD_PLANS_SUCCESS,
  LOAD_PLANS_ERROR,
  CHANGE_PLANS,
  CHANGE_PLANS_SUCCESS,
  CHANGE_PLANS_ERROR,
  DELETE_PLANS,
  DELETE_PLANS_SUCCESS,
  DELETE_PLANS_ERROR,
} from './constants';

/**
 * Clearing the state for Home
 */
export function flushStatePlans() {
  return {
    type: FLUSH_STATE_PLANS,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the Home, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_PLANS
 */
export function loadPlans() {
  return {
    type: LOAD_PLANS,
  };
}

/**
 * Dispatched when the loadPlans are loaded by the request saga
 *
 * @param  {array} variables true for Home
 *
 * @return {array} An action object with a type of LOAD_PLANS_SUCCESS passing the variables
 */
export function loadPlansSuccess(plansList) {
  return {
    type: LOAD_PLANS_SUCCESS,
    plansList,
  };
}

/**
 * Dispatched when loading the loadPlans fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_PLANS_ERROR passing the error
 */
export function loadPlansError(error) {
  return {
    type: LOAD_PLANS_ERROR,
    error,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the Plans, this action starts the request saga
 *
 * @return {array} An action object with a type of CHANGE_PLANS
 */
export function changePlans(plansData) {
  return {
    type: CHANGE_PLANS,
    plansData,
  };
}

/**
 * Dispatched when the changePlans are changed/updated by the request saga
 *
 * @param  {array} variables true for Plans
 *
 * @return {array} An action object with a type of CHANGE_PLANS_SUCCESS passing the variables
 */
export function changePlansSuccess(plansData) {
  return {
    type: CHANGE_PLANS_SUCCESS,
    plansData,
  };
}

/**
 * Dispatched when loading the changePlans fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of CHANGE_PLANS_ERROR passing the error
 */
export function changePlansError(error) {
  return {
    type: CHANGE_PLANS_ERROR,
    error,
  };
}

/**
 * ------------------ DELETE ------------------
 */

/**
 * Delete the Home, this action starts the request saga
 *
 * @return {object} An action object with a type of DELETE_PLANS
 */
export function deletePlans(id) {
  return {
    type: DELETE_PLANS,
    id,
  };
}

/**
 * Dispatched when the deletePlans are deleted by the request saga
 *
 * @param  {object} variables true for Home
 *
 * @return {object} An action object with a type of DELETE_PLANS_SUCCESS passing the variables
 */
export function deletePlansSuccess() {
  return {
    type: DELETE_PLANS_SUCCESS,
  };
}

/**
 * Dispatched when loading the deletePlans fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of DELETE_PLANS_ERROR passing the error
 */
export function deletePlansError(error) {
  return {
    type: DELETE_PLANS_ERROR,
    error,
  };
}
